/**
 * @description 受益人關係 Value (enum)
 */
export enum TargetBeneficiaryRelationshipValuesEnum {
  /** 配偶 */
  Spouse = '02',
  /** 父母 */
  Parents = '03',
  /** 子女 */
  Child = '04',
  /** 祖父母 */
  Grandparents = '05',
  /** 孫子女 */
  Grandchildren = '06',
  /** 法定繼承人 */
  LegalHeir = '11',
  /** 本人(要保人) */
  Policyholder = '01'
}
